import validator from "validator";

export const validateEmailAddress = (value: string) => {
  const emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
  return emailValid;
};
